import Multiselect from 'multiselect-react-dropdown';
import { asyncDebouncer } from '../../utils/helper';
import { captureMessage } from '@sentry/react';
import React, { useState, useEffect } from 'react';
import useDidMountEffect from '../../utils/useDidMountEffect';
import differenceBy from 'lodash/differenceBy';

const SuLookup = ({
    suToInclude,
    setSuToInclude
}) => {
    const [gettingPuList, setGettingPuList] = useState(false);
    const [pus, setPus] = useState([]);
    const [selectedLookup, setSelectedLookup] = useState([]);
    const [action, setAction] = useState('');
    const [removedItem, setRemovedItem] = useState('');

    const handleSearch = asyncDebouncer(async (keyword) => {
        setGettingPuList(true);
        await axios.get('/api/administration/creator-sales-boost/su-list', {
            params: {
                login: keyword,
                all: true
            }
        })
            .then(response => {
                setGettingPuList(false);
                setPus(response.data);
            })
            .catch(error => {
                setGettingPuList(false);
                captureMessage(error);
            });
    }, 800);

    const handleSelectSu = (selectedList, selectedItem) => {
        setSuToInclude(selectedList);
    };

    const handleRemove = (selectedList, removedItem) => {
        setSuToInclude(selectedList);
    };

    useEffect(() => {
        handleSearch('a%');
    }, []);

    return <div className="filter__pu">
        <label htmlFor="Sus">SU to add to the Draft Follower List</label>
        <Multiselect
            id="Sus"
            onSearch={handleSearch}
            options={pus}
            selectedValues={suToInclude}
            onSelect={handleSelectSu}
            onRemove={handleRemove}
            displayValue="name"
            emptyRecordMsg="No username match so far"
            loading={gettingPuList}
            placeholder={suToInclude ? 'Type to search SU' : ''}
            hidePlaceholder={suToInclude}
            closeOnSelect
        />
    </div>;
};

export default React.memo(SuLookup);
